/** Contract No. impreso en Invoice PTB (independiente del contrato PI/PTC). */
export function contractNoForPtbPdf(datosFormulario = {}) {
  return datosFormulario?.contractNoPtb ?? '';
}
